import React, { FC, useEffect, useState } from 'react'

interface TypewriterTextProps {
  children: (text: string) => React.ReactNode
  onComplete?: () => void
  speed?: number
  text: string
}

export const TypewriterText: FC<TypewriterTextProps> = ({
  children,
  onComplete,
  speed = 10,
  text,
}) => {
  const [displayedText, setDisplayedText] = useState('')
  const [isComplete, setIsComplete] = useState(false)

  useEffect(() => {
    if (!text) return

    setDisplayedText('')
    setIsComplete(false)

    let currentIndex = 0
    const intervalId = setInterval(() => {
      if (currentIndex < text.length) {
        // Add multiple characters per tick for faster streaming feel
        const charsToAdd = Math.min(3, text.length - currentIndex)
        setDisplayedText(text.slice(0, currentIndex + charsToAdd))
        currentIndex += charsToAdd
      } else {
        clearInterval(intervalId)
        setIsComplete(true)
        onComplete?.()
      }
    }, speed)

    return () => clearInterval(intervalId)
  }, [text, speed, onComplete])

  return <>{children(isComplete ? text : displayedText)}</>
}
